import PropTypes from 'prop-types';
import React, { Children } from 'react';
import { compose, branch, renderNothing, withPropsOnChange } from 'recompose';
import { get } from 'lodash';

import leftImage from 'assets/images/search/pagination-arrow-left.svg';
import rightImage from 'assets/images/search/pagination-arrow-right.svg';

import { Image } from 'components/core/Image';
import { PaginationItem } from 'components/core/Pagination';
import './pagination.scss';


export const enhance = compose(
	branch((props) => !props.pages || !props.pages.length, renderNothing),
	withPropsOnChange(
		['selectedPage', 'pages'],
		({ selectedPage, pages }) => {
			const pageIndex = selectedPage - 1;
			return ({
				prevPage: get(pages, pageIndex - 1, {}),
				nextPage: get(pages, pageIndex + 1, {})
			});
		}
	)
);

/**
 * SFDC Pagination Component. Renders a list of `PaginationItem`s representing the pages of results. Includes
 */
export function Pagination({
	pages, selectedPage, prevPage, nextPage, onPageChange
}) {
	return (
		<ul className="pagination">
			<PaginationItem
				page={prevPage}
				disabled={selectedPage <= 1}
				onPageChange={onPageChange}
			>
				<Image src={leftImage} alt={"leftArrow"}/>
			</PaginationItem>
			{Children.toArray(pages.map((page, index) => (
				<PaginationItem
					page={page}
					selected={index === selectedPage - 1}
					onPageChange={onPageChange}
				>
					{index + 1}
				</PaginationItem>
			)))}
			<PaginationItem
				page={nextPage}
				disabled={selectedPage >= pages.length}
				onPageChange={onPageChange}
			>
				<Image src={rightImage} alt={"Right Arrow"}/>
			</PaginationItem>
		</ul>
	);
}

Pagination.propTypes = {
	/** List of pages that should be included in the pagination component */
	pages: PropTypes.arrayOf(PropTypes.shape({
		/** Link to the indicated page */
		link: PropTypes.string
	})).isRequired,
	/** Indicates the currently selected page */
	selectedPage: PropTypes.number,
	/** number of pages to show in the pagination component */
	onPageChange: PropTypes.func,
	prevPage: PropTypes.object,
	nextPage: PropTypes.object
};

export default enhance(Pagination);
